<template>
  <div class="">
    <panel
      :Title="
        !$GetIsAnbohSaz() == false ? 'فرم ارتباط با مدیر' : 'فرم درخواست حضوری'
      "
      Des="از طریق این فرم می توانید پیامی در قالب متن را به مدیر سامانه ارسال نمایید."
      :IsBtnBack="true"
      ClassCustom="bg-dark-Custom text-right mt-2"
    ></panel>
    <div class="row">
      <div class="col-md-1 col-12"></div>
      <div class="col-md-10 col-12">
        <net-pa-card>
          <template slot="header">
            <h6>
              <i class="fas fa-comments mx-2"></i>
              {{
                !$GetIsAnbohSaz() == false
                  ? "ارتباط با مدیر"
                  : "فرم درخواست حضوری"
              }}
            </h6>
          </template>
          <template slot="content">
            <div class="row">
              <div class="col-md-4 col-12" v-if="isShowDateTimePicker == true">
                <small>تاریخ حضور</small>
                <date-picker
                  :editable="false"
                  :auto-submit="true"
                  color="#435ebe"
                  v-model="datetime"
                  type="datetime"
                >
                </date-picker>
              </div>
              <div class="col-12 mt-3">
                <small>متن پیام خود را بنویسید</small>
                <textarea
                  class="form-control mt-1"
                  @keypress="$BlockSuspiciousInput($event)"
                  @keyup="$BlockSuspiciousInput($event)"
                  rows="2"
                  ref="textarea"
                  @input="adjustHeight"
                  v-model="Txt"
                >
                </textarea>
              </div>
            </div>
            <div class="row px-2">
              <div class="col-md-4 col-12 p-2">
                <CaptchaBox
                  ref="captchaRef"
                  @update="onCaptchaValid"
                ></CaptchaBox>
              </div>
              <div class="col-md-5 col-12 p-2"></div>
              <div class="col-md-3 col-12 p-2">
                <button
                  class="btn btn-success rounded mt-1 Pointer w-100"
                  @click="SendMessage"
                  :disabled="!CaptchaValid"
                >
                  <i class="fas fa-paper-plane" aria-hidden="true"></i> ارسال
                  پیام
                </button>
              </div>
            </div>
          </template>
        </net-pa-card>
      </div>
      <div class="col-md-1 col-12"></div>
    </div>
  </div>
</template>
<script>
import Panel from "../Tools/NetPa/Panel.vue";
import NetPaCard from "../Tools/NetPa/NetPaCard.vue";
import CaptchaBox from "../CmpLogin/CaptchaBox.vue";

export default {
  data() {
    return {
      datetime: this.$GetJalaliDateTime(),
      Txt: "",
      DataAxiosRow: {
        ArryfildValue: "",
        Method: "Post",
        Action: "InsAzaMessage",
        Token: "",
      },
      CaptchaValid: false,
      captchaText: "",
      captchaId: "",
    };
  },
  components: { NetPaCard, Panel, CaptchaBox },
  methods: {
    refreshCaptcha() {
      this.$refs.captchaRef.generateCaptcha();
    },
    SendMessage() {
      if (this.isShowDateTimePicker == true) {
        this.Txt +=
          this.Txt + " \n [ " + " درخواست حضور برای : " + this.datetime + " ] ";
      }
      const formData = new FormData();
      formData.append(
        "wwwtblAzaId",
        this.$session.get("UserInfoNetPa").wwwtblAzaId,
      );
      formData.append(
        "wwwtblShobeId",
        this.$session.get("UserInfoNetPa").wwwtblShobeId,
      );
      formData.append("Message", this.Txt);
      formData.append("ZamanInsert", this.$GetJalaliDateTime());
      formData.append("userInput", this.captchaText);
      formData.append("captchaId", this.captchaId);
      this.DataAxiosRow.ArryfildValue = formData;
      this.DataAxiosRow.Token = this.$session.get("TokenNetPa");
      this.$PostFormData(this.DataAxiosRow).then((data) => {
        console.log(data);
        if (data.status == "NotOk") {
          this.refreshCaptcha();
          this.$mySweetDefault(
            "خطا",
            "کد یکبار مصرف اشتباه است",
            "error",
            3000,
          );
          return;
        }
        if (data.result == "SUCCESS") {
          this.$mySweetDefault(
            "عملیات موفق",
            "ارسال پیام با موفقیت انجام شد",
            "success",
            3000,
          );
          this.Txt = "";
        } else {
          this.$mySweetDefault(
            "خطایی رخ داده است",
            "در ارسال پیام خطایی رخ داده است",
            "error",
            3000,
          );
        }
      });
    },

    adjustHeight() {
      const textarea = this.$refs.textarea;
      textarea.style.height = "auto";
      textarea.style.height = `${textarea.scrollHeight}px`;
    },
    onCaptchaValid({ valid, captchaId, userInput }) {
      this.CaptchaValid = valid;
      this.captchaId = captchaId;
      this.captchaText = userInput;
    },
  },
  props: ["isShowDateTimePicker"],
  created() {
    // console.log(this.isShowDateTimePicker)
  },
};
</script>
<style scoped></style>
